export default __webpack_public_path__ + "static/media/pencil.12e043cd.svg";